import { render, staticRenderFns } from "./noReview.vue?vue&type=template&id=883ab1e0&scoped=true"
import script from "./noReview.vue?vue&type=script&lang=js"
export * from "./noReview.vue?vue&type=script&lang=js"
import style0 from "./noReview.vue?vue&type=style&index=0&id=883ab1e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883ab1e0",
  null
  
)

export default component.exports